/**
 * Safely read and parse a JSON value from localStorage.
 * Handles missing keys, the literal string "undefined"/"null", and corrupt JSON.
 */
export function readLocalStorageJSON(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === "" || raw === "undefined" || raw === "null") {
      if (raw === "undefined" || raw === "null") {
        localStorage.removeItem(key);
      }
      return fallback;
    }
    return JSON.parse(raw);
  } catch {
    localStorage.removeItem(key);
    return fallback;
  }
}

/**
 * Persist a value as JSON. Removes the key instead of writing
 * "undefined"/"null" when the value is undefined or null.
 */
export function writeLocalStorageJSON(key, value) {
  if (value === undefined || value === null) {
    localStorage.removeItem(key);
    return;
  }

  try {
    const serialized = JSON.stringify(value);
    // JSON.stringify(undefined) === undefined (not a string)
    if (serialized === undefined) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, serialized);
  } catch {
    localStorage.removeItem(key);
  }
}

/**
 * Remove known corrupt localStorage entries left by prior bad writes.
 */
export function scrubCorruptLocalStorage(keys = []) {
  keys.forEach((key) => {
    try {
      const raw = localStorage.getItem(key);
      if (raw === "undefined" || raw === "null") {
        localStorage.removeItem(key);
      }
    } catch {
      localStorage.removeItem(key);
    }
  });
}
